/**
 * Product-Search Component
 */

import { defineAsyncComponent } from 'vue';

import { getQuery } from '@root/src/framework/scripts/utils/url';
import { type App } from '~/app';

import { type FilterItems } from '../../../../framework/scripts/use/store/search/interfaces';
import { type MultiRangeSlider } from '../../form-and-content/fields/range-slider/interfaces';
import { type TabSelection } from '../../form-and-content/group-fields/tab-filter/interfaces';

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Stockland Product-Search Component');
    app.vueApp.component(
        'product-search',
        defineAsyncComponent(async () => import('./ProductSearch.vue'))
    );
    app.vueApp.component(
        'product-filter-modal',
        defineAsyncComponent(async () => import('./ProductFilterModal.vue'))
    );
    app.vueApp.component(
        'product-search-input',
        defineAsyncComponent(async () => import('./ProductSearchInput.vue'))
    );
    app.vueApp.component(
        'product-search-listing',
        defineAsyncComponent(async () => import('./ProductSearchListing.vue'))
    );
};

export function mapTabSelectionData(
    filterData: FilterItems,
    defaultSelection: string | undefined
): TabSelection | undefined {
    //check if querystring has the parent selection filter already set
    const currentQuery = getQuery();
    if (filterData.type == 'parent' && currentQuery?.filters) {
        const currentFilterQuery = JSON.parse(currentQuery.filters);
        if (filterData.id in currentFilterQuery) {
            defaultSelection = currentFilterQuery[filterData.id];
        }
    }

    if (filterData)
        return {
            id: filterData.id,
            title: filterData.title,
            type: filterData.type,
            items: filterData.items.map((x, index) => ({
                id: x.id,
                text: x.title,
                alternateTitle: x.alternateTitle ? x.alternateTitle : x.title,
                value: x.count,
                selected: defaultSelection ? x.id == defaultSelection ? true : false : (index == 0 ? true : false),
            })),
        };
}

const floor = (value: number) => Math.floor(value / 10) * 10
const ceil = (value: number) => Math.ceil(value / 10) * 10

export function mapMultiRangeSliderData(filterData: FilterItems, defaultSelection: number[]): MultiRangeSlider {
    // console.log('mapping range slider', defaultSelection);
    return {
        id: filterData.id,
        min: floor(Number.parseFloat(filterData.items.filter((x) => x.id == 'min').map((x) => x.title)[0] ?? 0)),
        max: ceil(Number.parseFloat(filterData.items.filter((x) => x.id == 'max').map((x) => x.title)[0] ?? 0)),
        minValue: defaultSelection
            ? defaultSelection[0]
            : floor(Number.parseFloat(filterData.items.filter((x) => x.id == 'min').map((x) => x.title)[0] ?? 0)),
        maxValue: defaultSelection
            ? defaultSelection[1]
            : ceil(Number.parseFloat(filterData.items.filter((x) => x.id == 'max').map((x) => x.title)[0] ?? 0)),
        prefix: filterData.items.filter((x) => x.id == 'prefix').map((x) => x.title)[0],
        suffix: filterData.items.filter((x) => x.id == 'suffix').map((x) => x.title)[0],
        step: filterData.items.filter((x) => x.id == 'step').map((x) => x.title)[0],
        label: filterData.title,
        type: filterData.type,
    };
}

export const filterIconMap = {
    state: 'location',
    area: 'lot-skinny',
    rent: 'dollar-rounded',
    term: 'search-skinny',
};
